import React from "react";
import { Link } from 'react-router-dom';

const CarEventos = ({ elemento, tardie = 0, autor = 'app' }) => {
    const { id_noticia, titulo, noticia, unidad, creado_por } = elemento;
    let url_detalle = '/detalleventos?id_noticia=' + id_noticia;
    let editarEvento = '/adminevento?id_noticia=' + id_noticia;
    let editar = 0;

    const noticiaBody = () => {
        return { __html: noticia };
    }

    if (creado_por.trim() === autor.trim()) {
        editar = 1;
    }

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <h5 className="card-title mb-0">{titulo}</h5>
                    {unidad ? (
                        <span className="esen-chip esen-chip--info ml-2">{unidad}</span>
                    ) : null}
                </div>
                <div className="esen-event-body mb-3" dangerouslySetInnerHTML={noticiaBody()}></div>
                <Link to={url_detalle} className="btn btn-primary btn-sm">
                    Leer completo
                </Link>
                {
                    tardie && editar ? (
                        <Link to={editarEvento} className="btn btn-outline-primary btn-sm ml-2">
                            <i className="fa fa-pencil mr-1" aria-hidden="true"></i> Editar
                        </Link>
                    ) : null
                }
            </div>
        </div>
    )
}

export default CarEventos;
